export default __webpack_public_path__ + "static/demo_allview-a72634a03031e000f1e89363a37ed4c1.gif";